<template>
  <div id='payPage'>
		   <div class='orderSureBox' v-if='orderSureShow'>
		   	<div class='orderSureTitle'>请确认支付已完成</div>
		   	<div class='orderSureBtn' @click="sureOrderPay">确定</div>
		   </div>
		   <div class='orderSurePop' v-if='orderSureShow'></div>
		   
		   <div class='orderSureBox' v-if='QQShow'>
		   	<div class='orderSureTitle'>支付出现了问题，请更换浏览器重试</div>
		   	<div class='orderSureBtn' @click="closeqq">确定</div>
		   </div>
		   <div class='orderSurePop' v-if='QQShow'></div>
		   
  </div>
</template>

<script>
export default {
  name: 'Alert',
  props: {
     orderid:Number
  },
  data:function(){
    return{
      orderSureShow:false,
	  QQShow:false,
	  isQQ:false,
    }
  },
 
 created:function(){
	this.createPay()
 },
  methods: {
   
	sureOrderPay(){
		this.$parent.closeOrderPay(this.orderid)
	},
    
	// 拉起微信h5支付
	weixinpay(){
		let _H5params = this.H5params
		console.log(this.H5params)
		let _url   = "https://syb.allinpay.com/apiweb/h5unionpay/unionorder?"
		_url=  _url + "cusid="+ _H5params.cusid
		_url=  _url + "&appid="+ _H5params.appid
		_url=  _url + "&version="+ _H5params.version
		_url=  _url + "&trxamt="+ _H5params.trxamt
		_url=  _url + "&reqsn="+ _H5params.reqsn
		_url=  _url + "&charset="+ _H5params.charset
		_url=  _url + "&returl="+ _H5params.returl
		_url=  _url + "&notify_url="+ _H5params.notify_url
		_url=  _url + "&body="+ _H5params.body
		_url=  _url + "&remark="+ _H5params.remark
		_url=  _url + "&randomstr="+ _H5params.randomstr
		_url=  _url + "&validtime="+ _H5params.validtime
		_url=  _url + "&limit_pay="+ _H5params.limit_pay
		_url=  _url + "&sign="+ _H5params.sign
		window.open(_url );
	},
	// 拉起支付宝h5支付
	zhifubaopay(){
		let _H5params = this.H5params
		window.open(_H5params.payinfo)
		this.orderSureShow = true
	},
	
	isWeiXin() {
			let _return = 1
	        let ua = window.navigator.userAgent.toLowerCase();
	        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
	            _return = 1 // 是微信端
	        } else {
	            _return = 2
	        }
			if(ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null){
				this.isQQ = true   // QQ浏览器
				  _return = 1
			}
			
			return _return
	},
	// 创建支付
	createPay(){
		let that = this
		
		let _isWeiXin = this.isWeiXin()
		if(this.isQQ){
			this.QQShow= true
			return
		}
		this.axios({
		              method: 'post',
		              url:"H5api/payOrder",
		              data:{
		                    member_id: this.$store.state.member_id ,
							order_id:this.orderid,
							pay_type:_isWeiXin,  // 1微信支付，2支付宝支付
		              }
		            }).then(res=>{
						if(_isWeiXin==1){
							that.H5params = res.data.params
							this.weixinpay()
						}else{
							that.H5params = res.data.resultPay
							this.zhifubaopay()
						}
					},ref=>{
						console.log(ref)
					})
	},
	closeqq(){
		this.QQShow= false
		this.$parent.closeOrderPay(this.orderid)
	},
  }
}
</script>  

<style>
#payPage{
	position: fixed;
	width: 7.5rem;
	height: 100vh;
	top:0;
	left: 0;
	z-index: 100;
	font-family:PingFangSC;
	z-index: 3;
	left:50%;
	transform: translate(-50%,0); 
}
.orderSureBox{
	width: 5.5rem;
	padding: 0.5rem;
	position: fixed;
	left: 50%;
	top:50%;
	transform: translate(-50%, -50%);  
	background-color: #fff;
	border-radius: 0.2rem;
	z-index: 100;
}
.orderSureTitle{
	line-height: 1rem;
	text-align: center;
	font-size: 0.28rem;
	color: #333333;
	font-family:PingFangSC-Medium,PingFang SC;
}
.orderSureBtn{
	width:2.1rem;
	line-height: 0.6rem;
	text-align: center;
	height:0.6rem;
	background:rgba(194,94,77,1);
	box-shadow:0px 5px 15px 0px rgba(237,196,185,0.35);
	border-radius:0.43rem;
	font-size:0.26rem;
	font-family:PingFangSC-Medium,PingFang SC;
	font-weight:500;
	color:rgba(255,255,255,1);
	margin: 0 auto;
}
.orderSurePop{
	width: 7.5rem;
	height: 100vh;
	background: rgba(0, 0, 0, 0.5);
	position: fixed;
	left: 50%;
	top:0;
	transform: translate(-50%, 0);  
	z-index: 99;
}
</style>